import { render, staticRenderFns } from "./NavigatorWithTitle.vue?vue&type=template&id=4f13542b&scoped=true&"
import script from "./NavigatorWithTitle.vue?vue&type=script&lang=js&"
export * from "./NavigatorWithTitle.vue?vue&type=script&lang=js&"
import style0 from "./NavigatorWithTitle.vue?vue&type=style&index=0&id=4f13542b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f13542b",
  null
  
)

export default component.exports